import { TreatmentPlanStatuses } from "../enum";

export const treatPlanStatus: Record<TreatmentPlanStatuses, string> = {
  [TreatmentPlanStatuses.APPROVED]: "Approved",
  [TreatmentPlanStatuses.DRAFT]: "Draft",
  [TreatmentPlanStatuses.PENDING_APPROVAL]: "Pending approval",
};
